import { AxiosError } from 'axios';
import { getJsonConfig } from '@rmc/webcx-web-libs';
import { useQuery } from '@tanstack/react-query';
import {
	API_URL_CAMPAIGNS_CONFIG,
	CAMPAIGNS_JSON_FILE_NAME,
} from '../../../config';
import { getError } from '../../getError';

type CampaignsApiGetType = {
	clientId: string;
	isPreview?: boolean;
};

function isNotFound(e: unknown) {
	return e instanceof AxiosError && e?.response?.status === 404;
}

export function useCampaignsApiGet({
	clientId = '',
	isPreview = false,
}: CampaignsApiGetType) {
	return useQuery({
		queryFn: async () => {
			try {
				const { data } = await getJsonConfig({
					clientId,
					jsonFileName: CAMPAIGNS_JSON_FILE_NAME,
					apiUrlCampaignsConfig: API_URL_CAMPAIGNS_CONFIG,
				});

				return Array.isArray(data) ? data : [data];
			} catch (e) {
				// In case of no client ID - API responds with 404
				// But it doesn't mean an issue.
				// It might be 404 since the campaign has not been created yet
				if (isNotFound(e)) {
					return [];
				}

				throw getError(e);
			}
		},
		queryKey: ['jsonCampaigns', clientId, isPreview],
		enabled: !!clientId && !isPreview,
		retry: false,
		refetchOnWindowFocus: false,
	});
}
